module.exports = __webpack_public_path__ + "static/media/como-12.06eb01b2.jpg";